/** * 系统操作日志 */
<template>
	<div>
		<topTab ref="topTab" :tabData='tabData' @tabChange='changePages'>
			<!-- 搜索筛选 -->
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="模块类型：">
					<el-input size="small" @keyup.enter.native="search" v-model="formInline.apiModule"
						placeholder="请输入模块类型"></el-input>
				</el-form-item>
				<el-form-item label="起止日期：">
					<el-date-picker size="small" v-model="timeData" value-format="yyyy-MM-dd"
						@keyup.enter.native="inputChange" @change="timeChange" @input="$forceUpdate()" type="daterange"
						start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
        <el-form-item label="操作人：">
          <el-select v-model="formInline.operateUserId" placeholder="请选择操作人" clearable size="small" filterable
            @change="getListData">
            <el-option v-for="item in operatorList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
				<el-form-item class="btnList">
					<el-button size="small" type="primary" icon="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
				</el-form-item>
				<el-form-item style="float: right;margin-right: 0;">
					<my-column-filter :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter>
				</el-form-item>
			</el-form>
			<!--列表-->
			<STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" :rowKey="'keyId'">
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
		</topTab>
	</div>

</template>

<script>
import {
	GetSystemOperationLogList
} from '../../../api/systemApi.js';
import {
	GetUserInfoSimpleDropList
} from '@/api/userApi.js';

export default {
	data() {
		return {
			activeTab: '1',
			tabData: [{
				key: '1',
				value: '日志记录'
			}],
			pageShow: true,
			loading: false, // 显示加载
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				startTime: null,
				endTime: null,
				operateUserId: ""
			},
			operatorList: [],
			listData: [],
			timeData: [],
			columnsData: [], //显示列
			listColumns: [{
				prop: 'rowNumber',
				label: '序号',
				align: 'center',
				fixed: 'left',
				width: '60',
				isKeep: true
			}, {
				prop: 'title',
				label: '事件类型',
				align: 'center',
          width: "160",
				isKeep: true
			}, {
				prop: 'apiModule',
				label: '模块',
				align: 'center',
          width: "140",
			},
			{
				prop: 'operatorName',
				label: '操作人',
				align: 'center',
          width: "100",
			}, {
				prop: 'createTime',
				label: '操作时间',
				align: 'center',
          width: "170",
			}, {
				prop: 'content',
				label: '操作内容',
			}
			],
		};
	},
	// 注册组件
	components: {

	},
	/**
	 * 创建完毕
	 */
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map(item => item.label))
		this.getListData();
		this.getOperatorList();
	},
	computed: {},
	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter(v => !val.includes(v.label))
			this.columnsData = this.listColumns.filter(i => !arr.includes(i));
		},
		changePages() { },
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.timeData = [];
			this.inputChange();
		},
		timeChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
		},
		// 查询
		inputChange() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		//获取人员信息
		getOperatorList(){
			GetUserInfoSimpleDropList({}).then((res) => {
				if (res.code == 1) {
					this.operatorList = res.data.map(item => ({
						keyId: item.keyId,
						value: item.chName
					}));
				} else {
					this.$message({
						type: 'info',
						message: '暂无数据',
					});
				}
			})
			.catch((err) => {
				this.loading = false;
				this.$message.error('数据加载失败，请稍后再试！');
			});
		},
		// 获取列表
		getListData() {
			GetSystemOperationLogList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: 'info',
							message: '暂无数据',
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error('数据加载失败，请稍后再试！');
				});
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
	},
};
</script>

<style scoped>
.year {
	color: #409EFF;
	position: absolute;
	left: -166px;
	top: 1px;
}
</style>